__turbopack_context__.v({
  "cardCopy": "bkjDOW_cardCopy",
  "cardGrid": "bkjDOW_cardGrid",
  "cardPreview": "bkjDOW_cardPreview",
  "eyebrow": "bkjDOW_eyebrow",
  "formError": "bkjDOW_formError",
  "homeSection": "bkjDOW_homeSection",
  "loadingState": "bkjDOW_loadingState",
  "sectionHeading": "bkjDOW_sectionHeading",
  "showcaseCard": "bkjDOW_showcaseCard",
});
